import './main.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter, Route, Routes } from 'react-router-dom';
import styled from 'styled-components';

import { ErrorBoundary } from '../../components/error-handling/BugsnagErrorBoundary';
import { Header } from '../../components/Header';
import { Navigation } from '../../components/navigation/navigation';
import { DatabaseContextProvider } from '../../screens/DatabaseContextProvider';
import { JiraContextProvider } from '../../screens/JiraContextProvider';
import { LicenseChecker } from '../../screens/LicenseChecker';
import { PersonalConfigurationProvider } from '../../screens/PersonalConfigurationProvider';
import { ThemeProvider } from '../../screens/ThemeProvider';
import { TogglDataProvider } from '../../screens/TogglDataProvider';
import { TogglAccountTokenProvider } from '../../screens/ToggleAccountTokenProvider';
import { AppRouter } from '../../services/router';
import { ConfigMyEntries } from '../../views/configuration/my-entries';
import { ConfigPersonal } from '../../views/configuration/personal';
import { ConfigProjects } from '../../views/configuration/projects';
import { ConfigUsers } from '../../views/configuration/users';

const ContentWrapper = styled.div`
  padding-left: 8px;
  min-height: 0;
`;

const MainLayoutWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 24px;
  height: 100%;
`;

const MainLayout = styled.div`
  width: 1015px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

function Main() {
  return (
    <HashRouter>
      <AppRouter>
        <Header />
        <Navigation />
        <ContentWrapper data-testid="main-layout">
          <Routes>
            <Route path="/" element={<ConfigMyEntries />} />
            <Route path="/users" element={<ConfigUsers />} />
            <Route path="/projects" element={<ConfigProjects />} />
            <Route path="/configuration" element={<ConfigPersonal />} />
          </Routes>
        </ContentWrapper>
      </AppRouter>
    </HashRouter>
  );
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <ErrorBoundary>
    <ThemeProvider>
      <MainLayoutWrapper>
        <MainLayout>
          <JiraContextProvider>
            <LicenseChecker>
              <DatabaseContextProvider>
                <TogglAccountTokenProvider>
                  <TogglDataProvider>
                    <PersonalConfigurationProvider>
                      <Main />
                    </PersonalConfigurationProvider>
                  </TogglDataProvider>
                </TogglAccountTokenProvider>
              </DatabaseContextProvider>
            </LicenseChecker>
          </JiraContextProvider>
        </MainLayout>
      </MainLayoutWrapper>
    </ThemeProvider>
  </ErrorBoundary>
);
